import { ProductGroup } from "@/types/product";

export const productGroups: ProductGroup[] = [
  {
    id: "avoip",
    name: "AV Over IP",
    description: "Complete AV distribution solution with ultra-low latency",
    image: "/lovable-uploads/3c5e0e75-dc47-418a-a095-e7a676bd935c.png",
    images: [
      "/lovable-uploads/5fe89d72-89ec-49e5-b73d-bbc998b49786.png",
      "/lovable-uploads/bac51e44-bd59-4169-b2f1-06a5107d9d6c.png"
    ],
    slug: "avoip"
  },
  {
    id: "reax-control",
    name: "ReAX Control",
    description: "Professional control system solutions",
    image: "/lovable-uploads/3f8b76bd-e087-4dd8-b83f-b4aa978fd129.png",
    slug: "reax-control"
  },
  {
    id: "reax-touch-controllers",
    name: "Touch Controllers",
    description: "Professional touch panel interfaces",
    image: "/lovable-uploads/1c94a2db-5324-4f27-b1ce-4673b28597bb.png",
    slug: "reax-touch-controllers"
  },
  {
    id: "reax-controllers",
    name: "Controllers",
    description: "Advanced control processors",
    image: "/lovable-uploads/63502d4f-94ae-4263-9930-af882e407a3e.png",
    slug: "reax-controllers"
  },
  {
    id: "reax-software",
    name: "ReAX Software",
    description: "Professional control system development software",
    image: "/lovable-uploads/1f12f184-1a1c-48ea-bf40-59ff42404b0c.png",
    slug: "reax-software"
  },
  {
    id: "reax-accessories",
    name: "ReAX Accessories",
    description: "Essential accessories for ReAX systems",
    image: "/lovable-uploads/4d2d847f-cdc2-4e60-8911-5dcdf710a78b.png",
    slug: "reax-accessories"
  },
  {
    id: "audio-products",
    name: "Audio Products",
    description: "Professional audio processing and playback solutions",
    image: "/lovable-uploads/de5193b2-fbb5-4c77-b24b-c9d23fab4012.png",
    slug: "audio-products"
  },
  {
    id: "audio-dsps",
    name: "DSP's",
    description: "Digital Signal Processors for advanced audio control",
    image: "/lovable-uploads/3ab44682-1c92-4d7a-b99f-7e665e65c005.png",
    slug: "audio-dsps"
  },
  {
    id: "audio-amplifiers",
    name: "Amplifiers",
    description: "Professional audio amplification solutions",
    image: "/lovable-uploads/de5193b2-fbb5-4c77-b24b-c9d23fab4012.png",
    slug: "audio-amplifiers"
  },
  {
    id: "audio-speakers",
    name: "Speakers",
    description: "High-quality professional speakers",
    image: "/placeholder.svg",
    slug: "audio-speakers"
  },
  {
    id: "meeting-room",
    name: "Meeting Room / ReAX Room Solutions",
    description: "Complete solutions for modern meeting spaces",
    image: "/lovable-uploads/ba49821c-da0f-4aec-abd4-65fbfe07bea7.png",
    slug: "meeting-room"
  },
  {
    id: "ipbaset",
    name: "IPBaseT",
    description: "Advanced IP-based AV distribution platform",
    image: "/lovable-uploads/f3d6ba50-9d6f-47f8-90d1-58e7bb23eb9b.png",
    images: [
      "/lovable-uploads/f3d6ba50-9d6f-47f8-90d1-58e7bb23eb9b.png",
      "/lovable-uploads/56a1755b-4753-4c85-8418-9b044ce92492.png",
      "/lovable-uploads/677aca6b-6dbe-443b-9225-663c4d2a7828.png",
      "/lovable-uploads/9e249f58-5d98-498b-a5ef-d4f7704ef3fe.png"
    ],
    slug: "ipbaset"
  },
  {
    id: "hdbaset",
    name: "HDBaseT Products",
    description: "Professional HDBaseT distribution solutions",
    image: "/lovable-uploads/e656b596-3b77-42bf-a41d-74da7e4b0760.png",
    slug: "hdbaset"
  },
  {
    id: "converters-scalers",
    name: "Converters/Scalers",
    description: "Professional format conversion and scaling solutions",
    image: "/lovable-uploads/d8c5f2b3-f631-4bf8-9c10-1a5c3213b58f.png",
    slug: "converters-scalers"
  },
  {
    id: "hdmi-switchers",
    name: "HDMI Switchers",
    description: "Professional HDMI switching and distribution solutions",
    image: "/lovable-uploads/31d19994-b169-4955-ac33-254294c09875.png",
    slug: "hdmi-switchers"
  }
];
